import React from 'react';
import style from './style/criticalthinking.scss';
import { badge__sectionBlock, scoreBlockWhite, sectionBlock_subtitle } from '../Grid/style/grid.scss';

import ScoreBarTypes from '../../constants/ScoreBarTypes';

import ScoreBarNG from '../ScoreBarNG/ScoreBarNG';
import SectionBlock from '../SectionBlock/SectionBlock';

export const CriticalThinking = (props) => {
    const {
        i18nParticipation,
        icon,
        section
    } = props;

    const scoreValue = section.scores[0]?.score;

    return (
        <SectionBlock
            classes={ {
                badge: {
                    root: badge__sectionBlock,
                    figure: icon
                },
                root: scoreBlockWhite
            } }
        >
            <span className={ `${sectionBlock_subtitle} ${style.criticalThinking_subtitle}` }>
                { section.basedOn || i18nParticipation.report_section_based_on_default_text }
            </span>
            <h3 className={ style.criticalThinking_title }>{ i18nParticipation.report_critical_thinking }</h3>
            <p className={ style.criticalThinking_text }>{ section.introduction }</p>
            <span className={ style.scoreBarCriticalThinking__wrapper }>
                <ScoreBarNG
                    digits={ 2 }
                    disabled={ true }
                    fill={ false }
                    scoreBarType={ ScoreBarTypes.CUTOFF }
                    scoreMax={ 9 }
                    scoreMin={ 1 }
                    scoreValue={ scoreValue }
                    valueLabelDisplay={ 'off' }
                />
                { scoreValue }
            </span>
        </SectionBlock>
    )
}
